/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Kanban_Archived_LabelInputs */



/**
* | output |
* | --- |
* | "Archived" |
*
* @param {Explorer_Kanban_Archived_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_kanban_archived_label = /** @type {((inputs?: Explorer_Kanban_Archived_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Kanban_Archived_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Archive")
	if (locale === "de") return /** @type {LocalizedString} */ ("Archiviert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Archiviato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Архив")
	if (locale === "es") return /** @type {LocalizedString} */ ("Archivado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("已存档")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アーカイブ済み")
	if (locale === "hi") return /** @type {LocalizedString} */ ("संग्रहीत")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Arquivado")
	return /** @type {LocalizedString} */ ("Archived")
});